import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const api = axios.create({ withCredentials: true});

// Contact API
export const contactAPI = {
  sendMessage: async (data) => {
    try {
      const response = await api.post(`${API_URL}/contact`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  getAllMessages: async () => {
    try {
      const response = await api.get(`${API_URL}/contact/all`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  deleteMessage: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/contact/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Chatbot API
export const chatbotAPI = {
  sendMessage: async (message, sessionId) => {
    try {
      const response = await api.post(`${API_URL}/chatbot`, {
        message,
        sessionId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Portfolio API
export const portfolioAPI = {
  // Get all portfolio data
  getPortfolioData: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Hero APIs
  getHero: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/hero`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateHero: async (data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/hero`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // About APIs
  getAbout: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/about`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateAbout: async (data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/about`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Projects APIs
  getProjects: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/projects`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  getProjectById: async (id) => {
    try {
      const response = await api.get(`${API_URL}/portfolio/projects/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createProject: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/projects`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateProject: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/projects/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteProject: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/projects/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Skills APIs
  getSkills: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/skills`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createSkill: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/skills`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateSkill: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/skills/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteSkill: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/skills/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Experience APIs
  getExperience: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/experience`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createExperience: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/experience`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateExperience: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/experience/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteExperience: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/experience/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Education APIs
  getEducation: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/education`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createEducation: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/education`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateEducation: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/education/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteEducation: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/education/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Certifications APIs
  getCertifications: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/certifications`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createCertification: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/certifications`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateCertification: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/certifications/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteCertification: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/certifications/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Problems Solved APIs
  getProblemsSolved: async () => {
    try {
      const response = await api.get(`${API_URL}/portfolio/problems-solved`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  createProblemSolved: async (data) => {
    try {
      const response = await api.post(`${API_URL}/portfolio/problems-solved`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  updateProblemSolved: async (id, data) => {
    try {
      const response = await api.put(`${API_URL}/portfolio/problems-solved/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  deleteProblemSolved: async (id) => {
    try {
      const response = await api.delete(`${API_URL}/portfolio/problems-solved/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Auth API
export const authAPI = {
  login: async (credentials) => {
    try {
      const response = await api.post(`${API_URL}/auth/login`, credentials);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  logout: async () => {
    try {
      const response = await api.post(`${API_URL}/auth/logout`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  verifyToken: async () => {
    try {
      const response = await api.get(`${API_URL}/auth/online`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};